import { ObjectIdAsHexString } from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z.object({
  targetId: ObjectIdAsHexString,
  type: z.enum(["artwork", "collection"]).default("artwork"),
  content: z.string().max(5000),
  replyTo: ObjectIdAsHexString.optional(),
});

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  insertedId: z.string(),
});

export type Result = z.infer<typeof Result>;

export type CreateComment$Params = Params;
export const CreateComment$Params = Params;
export type CreateComment$Result = Result;
export const CreateComment$Result = Result;
